// Phase 7 R2 — Procurement state pill for parts_lines.
// Phase 7 R5 — Pill becomes opt-in visible on `not_ordered` via `showNotOrdered`.
//
// PRESENTATIONAL ONLY. Eligibility, filtering, and any business logic must read
// `procurement_status` directly from the parts_line row and must NEVER infer
// state from pill visibility. Consumers never read pill state back.
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { ProcurementStatus } from '@/hooks/parts/usePartsLines';

const LABELS: Record<ProcurementStatus, string> = {
  not_ordered: 'Not Ordered',
  ordered: 'Ordered',
  partially_received: 'Partial',
  received: 'Received',
  partially_returned: 'Partial Return',
  returned: 'Returned',
};

const VARIANT: Record<ProcurementStatus, 'default' | 'secondary' | 'destructive' | 'outline'> = {
  not_ordered: 'outline',
  ordered: 'secondary',
  partially_received: 'secondary',
  received: 'default',
  partially_returned: 'secondary',
  returned: 'outline',
};

interface Props {
  status: ProcurementStatus;
  className?: string;
  /**
   * R5: when true, the pill renders even for `not_ordered`. Default `false`
   * preserves R2 behavior so existing call sites are unchanged.
   */
  showNotOrdered?: boolean;
}

export function ProcurementStatusPill({ status, className, showNotOrdered = false }: Props) {
  if (status === 'not_ordered' && !showNotOrdered) return null;
  return (
    <Badge variant={VARIANT[status]} className={cn('text-[10px] py-0 h-4', className)}>
      {LABELS[status]}
    </Badge>
  );
}
